var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"cont",staticStyle:{"position":"relative"},attrs:{"id":"app"}},[(_vm.isShow)?_c('allHead',{staticStyle:{"position":"absolute"}}):_vm._e(),(_vm.isShow)?_c('router-view'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }